import { z } from 'zod';

import { VALIDATION_MESSAGES } from '@/constants/constant';

export const changePasswordSchema = z
  .object({
    currentPassword: z
      .string()
      .trim()
      .nonempty(VALIDATION_MESSAGES.currentPassword.required)
      .min(8, VALIDATION_MESSAGES.currentPassword.min)
      .max(20, VALIDATION_MESSAGES.currentPassword.max),
    newPassword: z
      .string()
      .trim()
      .nonempty(VALIDATION_MESSAGES.password.required)
      .min(8, VALIDATION_MESSAGES.password.min)
      .max(20, VALIDATION_MESSAGES.password.max)
      .refine((val) => /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,20}$/.test(val), {
        message: VALIDATION_MESSAGES.password.strength,
      }),
    confirmNewPassword: z
      .string()
      .trim()
      .nonempty(VALIDATION_MESSAGES.confirmPassword.required)
      .min(8, VALIDATION_MESSAGES.confirmPassword.min)
      .max(20, VALIDATION_MESSAGES.confirmPassword.max),
  })
  .refine((data) => data.newPassword === data.confirmNewPassword, {
    message: VALIDATION_MESSAGES.confirmPassword.match,
    path: ['confirmNewPassword'],
  });

export type TChangePassword = z.infer<typeof changePasswordSchema>;
